import "@brickme/frontend-common/src/polyfill/form-request-submit.ts";
import "invokers-polyfill";
import { render } from "preact";
import { StrictMode } from "preact/compat";
import initMonitoring from "@brickme/frontend-common/src/monitoring/init-monitoring.ts";
import { optionalEnv, requiredEnv } from "./utils/ensure-env.ts";
import App from "./app/app.tsx";
import { parseJsonRegions } from "./utils/region.ts";
import packageInfo from "../package.json";
import "./styles/global.css";

initMonitoring({
	sentryDsn: optionalEnv("VITE_SENTRY_DSN"),
	sentryEnvironment: optionalEnv("VITE_SENTRY_ENVIRONMENT"),
	number: packageInfo.version,
	buildTimestamp: requiredEnv("VITE_BUILD_TIMESTAMP"),
	commitId: requiredEnv("VITE_VERSION_ID"),
});

// Fix vh for mobile browsers. See https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
function updateViewHeight() {
	const vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty("--vh", `${vh}px`);
}
updateViewHeight();
window.addEventListener("resize", updateViewHeight);

render(
	<StrictMode>
		<App
			userAgent={navigator.userAgent || navigator.vendor || "unknown"}
			regionConfigs={parseJsonRegions(requiredEnv("VITE_REGIONS"))}
			ipInfoToken={requiredEnv("VITE_IP_INFO_TOKEN")}
		/>
	</StrictMode>,
	// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	document.getElementById("root")!,
);

// console.error("TODO: Remove this testing code");
// const myUnusedVar = "prevents accidental commit"
// async function waitForReactRender() {
// 	return new Promise((resolve) => setTimeout(resolve, 0));
// }
// async function waitForElement<T extends HTMLElement>(selector: string, predicate?: <T extends HTMLElement>(element: T) => boolean) {
// 	const start = new Date();
// 	return new Promise<T>((resolve) => {
// 		const interval = setInterval(() => {
// 			const end = new Date();
// 			if ((end.getTime() - start.getTime()) > 5_000) {
// 				throw new Error(`Timeout for ${selector}`)
// 			}

// 			const elements = document.querySelectorAll<T>(selector);

// 			// Keep waiting
// 			if (elements.length === 0) {
// 				return;
// 			}

// 			const predicateMatches = Array.from(elements).filter(e => !predicate || predicate(e));

// 			if (predicateMatches.length > 1) {
// 				throw new Error("Multiple matches found for " + selector);
// 			}

// 			if (predicateMatches.length === 1) {
// 				clearInterval(interval);
// 				resolve(predicateMatches[0]);
// 				return;
// 			}
// 		}, 100);
// 	});
// }

// await waitForReactRender();
// const buttons = document.evaluate(
// 	"//button[contains(., 'I have a kit')]",
// 	document,
// 	null,
// 	XPathResult.ANY_TYPE,
// 	null,
// );
// const button = buttons.iterateNext();
// button?.dispatchEvent(new MouseEvent("click", { bubbles: true }));

// const input = await waitForElement<HTMLInputElement>('input[type="text"]');
// input.value = "TEST01";
// const submit = await waitForElement<HTMLButtonElement>(
// 	'button[type="submit"]', e => e.innerHTML.includes("Next")
// );
// submit.dispatchEvent(new MouseEvent("click", { bubbles: true }));

// const oneKitRadio = await waitForElement<HTMLInputElement>('input[type="radio"][value="4"]');
// oneKitRadio.setAttribute("checked", "checked");
// const submitKits = await waitForElement<HTMLButtonElement>(
// 	'button[type="submit"]', e => e.innerHTML.includes("Submit")
// );
// submitKits.dispatchEvent(new MouseEvent("click", { bubbles: true }));

// const { default: image } = await import("./features/editor/complete/parrot-colour.png");
// const response = await fetch(image);
// const blob = await response.blob();
// const uploadLabel = (await waitForElement('input[type="file"]', e => (e as HTMLInputElement).name === "sourceImage")).closest("label")!;
// const event = new Event("drop");
// (event as any).dataTransfer = {
// 	files: [new File([blob], "tiger.png", { type: "image/png" })],
// };
// uploadLabel.dispatchEvent(event);
// const confirmPhoto = await waitForElement<HTMLButtonElement>(
// 	'button[type="button"]',
// 	(element) => element.innerHTML.includes("Next") && !element.getAttribute("disabled")
// );
// confirmPhoto.dispatchEvent(new MouseEvent("click", { bubbles: true }));

// // Select a layout
// const layout = await waitForElement<HTMLButtonElement>(
// 	'button[aria-label="4x4"]',
// );
// layout.dispatchEvent(new MouseEvent("click", { bubbles: true }));

// 	const adjustButton = await waitForElement<HTMLButtonElement>(
// 		'button[aria-label="Adjust"]',
// 	);
// 	adjustButton.dispatchEvent(new MouseEvent("click", { bubbles: true }));
// 	const detailButton = await waitForElement<HTMLButtonElement>(
// 		'button[aria-label="Detail"]',
// 	);
// 	detailButton.dispatchEvent(new MouseEvent("click", { bubbles: true }));

// 	const finishButton = await waitForElement<HTMLButtonElement>(
// 		'button[aria-label="Finish"]',
// 	);
// 	finishButton.dispatchEvent(new MouseEvent("click", { bubbles: true }));

// 	// Add colours
// 	const addColoursButton = await waitForElement<HTMLButtonElement>(
// 		'button[aria-label="Add colors?"]',
// 	);
// 	addColoursButton.dispatchEvent(new MouseEvent("click", { bubbles: true }));
// 	const letsAddColoursButton = await waitForElement<HTMLButtonElement>(
// 		'button[aria-label="Let\'s add colors"]',
// 	);
// 	letsAddColoursButton.dispatchEvent(new MouseEvent("click", { bubbles: true }));

// 	// Go to finish again
// 	const finish2Button = await waitForElement<HTMLButtonElement>(
// 		'button[aria-label="Finish"]',
// 	);
// 	finish2Button.dispatchEvent(new MouseEvent("click", { bubbles: true }));
